export const formatCurrency = (amount, currency = 'EUR', locale = 'nl-NL') => {
  if (amount == null || isNaN(amount)) {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(0);
  }
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount);
};

export const formatNumber = (amount, locale = 'nl-NL', options = {}) => {
  if (amount == null || isNaN(amount)) return '';
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...options,
  }).format(amount);
};
